/* ==========================================================================
 *  Calendar
 * ======================================================================= */
function fn_components_calendar(){
	if ($('.flatpickr').length){
		
		var months = new Array(12);
		months[0] = "Jan";
		months[1] = "Feb";
		months[2] = "Mar";
		months[3] = "Apr";
		months[4] = "May";
		months[5] = "Jun";
		months[6] = "Jul";
		months[7] = "Aug";
		months[8] = "Sep";
		months[9] = "Oct";
		months[10] = "Nov";
		months[11] = "Dec";

		$('.flatpickr').each(function(){
		    var inst = $(this);
		    var thisClass = inst.data('class');
			inst.flatpickr({
				dateFormat: "d/M",
				onChange: function(selectedDates, dateStr, instance) {
					var dateStr;
					var selectedDate = dateStr.split("/");
					console.log(selectedDate);
					inst.find('.input-day').text(selectedDate[0]);
					inst.find('.input-month').text(selectedDate[1]);
					if (!$('.modal-block').hasClass('active')){
						var calendarModal = $('.modal-block').find('.flatpickr[data-class=' + thisClass + ']');
						calendarModal.find('.input-day').text(selectedDate[0]);
						calendarModal.find('.input-month').text(selectedDate[1]);
					} else {
						var calendarOffer = $('.js-main-offer-form').find('.flatpickr[data-class=' + thisClass + ']');
						calendarOffer.find('.input-day').text(selectedDate[0]);
						calendarOffer.find('.input-month').text(selectedDate[1]);
					}
				},
				onReady: function(selectedDates, dateStr, instance) {
					var month = months[instance.now.getMonth()];
					var day = instance.now.getDate();
					inst.find('.input-day').text(day);
					inst.find('.input-month').text(month);
				}
			});
	    });


	}

}
